
import AxiosStore from './axios'
import GlobalStore from './global'
export const globalStore = new GlobalStore()
export const axiosStore = new AxiosStore()